var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenueRightCornerWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 54,
    viewBox: "0 0 91 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4615 40.0455C90.4369 47.3883 84.4768 53.3333 77.1283 53.3333H0C3.58978 43.3332 18.5847 23.3333 49.8461 23.3333C81.1077 23.3333 89.9487 7.77778 90.4615 0V40.0455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueRightCornerWave);
export default __webpack_public_path__ + "static/media/revenueRightCornerWave.e7e61f9fe1533f556c40c96e3906735c.svg";
export { ForwardRef as ReactComponent };